import { RedoButton } from "@redotech/arbiter/buttons/redo-button";
import { RedoCollapseSubsection } from "@redotech/arbiter/collapse/redo-collapse-section";
import { Flex } from "@redotech/arbiter/flex";
import { RedoTextareaInputField } from "@redotech/arbiter/input/redo-textarea-input-field";
import { Text } from "@redotech/arbiter/text";
import UploadCloudIcon from "@redotech/redo-icons/upload-cloud-02.svg";
import { memo } from "react";
import {
  GorgiasImportType,
  useGorgiasImport,
} from "../../gorgias-import/use-gorgias-import";

export const GorgiasTagsTab = memo(function GorgiasTagsTab({
  teamId,
}: {
  teamId: string | undefined;
}) {
  const { jsonText, setJsonText, loading, handleImport } = useGorgiasImport({
    teamId,
    importType: GorgiasImportType.TAGS,
  });

  return (
    <Flex dir="column" gap="md">
      <Text fontSize="sm" textColor="secondary">
        Paste the JSON response from the Gorgias tags API endpoint. Tags will be
        created with their colors mapped to our available themes.
      </Text>
      <RedoCollapseSubsection title="Instructions">
        <Flex dir="column" gap="sm" pl="lg">
          <Text fontSize="sm" textColor="secondary">
            To add this import:
          </Text>
          <Text fontSize="sm" textColor="secondary">
            <li>
              • Go to Gorgias and open your developer tools (right click,
              inspect)
            </li>
            <li>• Go to the network tab</li>
            <li>• Search for "/api/tags/?limit"</li>
            <li>• Go to the tags settings in Gorgias</li>
            <li>
              • You'll need to go through every tag page and paste the response
              each time (tags are paginated)
            </li>
            <li>
              • Copy the response from each page and paste it into this input,
              then click Import Tags before moving to the next page
            </li>
          </Text>
        </Flex>
      </RedoCollapseSubsection>
      <RedoTextareaInputField
        disabled={loading}
        label="Gorgias Tags JSON"
        placeholder='Paste Gorgias tags JSON here (e.g., {"object": "list", "data": [...]})'
        setValue={setJsonText}
        value={jsonText}
      />
      <div>
        <RedoButton
          disabled={!jsonText.trim() || loading}
          hierarchy="primary"
          IconLeading={UploadCloudIcon}
          onClick={() => handleImport({ jsonText })}
          pending={loading}
          size="md"
          text="Import Tags"
          theme="normal"
        />
      </div>
    </Flex>
  );
});
